import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    footer: {
        padding: theme.spacing(3, 6),
        marginTop: theme.spacing(2)
    },
}));